import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import {
  Button,
  TextField,
  CardHeader,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Checkbox,
  FormControl,
  MenuItem
} from '@material-ui/core';
import {editCustomOptionApi} from 'api';


const EditCustomOption = ({open, onClose, options = [], option, types}) => {
  const dispatch = useDispatch();

  const customOptionsSortOrders = options.map((option) => option.sort_order).filter((i) => i !== option.sort_order);
  const {
    title,
    option_id,
    type,
    sort_order,
    is_require,
    is_swatch,
    values,
    product_sku,
    dermpro_option_gallery,
    dermpro_option_image_mode
  } = option;
  return (
    <Dialog
      fullWidth
      maxWidth={'md'}
      open={open}
      onClose={() => onClose(false)}
      aria-labelledby="edit-custom-option"
    >
      <DialogContent>
        <Formik
          initialValues={{
            option_id,
            product_sku,
            title,
            sort_order,
            type,
            is_require,
            is_swatch,
            dermpro_option_gallery,
            dermpro_option_image_mode,
            images: [],
            values
          }}
          enableReinitialize
          validationSchema={yup.object(
            {title: yup
              .string()
              .required('Option name is required')
              .min(2, 'Must be at least 2 characters'),
            sort_order: yup
              .number()
              .notOneOf(customOptionsSortOrders, 'Sort order already specified')
              .nullable().typeError('Allowed numbers only')
              .integer('Order must be an integer')
              .min(0, 'Invalid sort_order number')
              .required('Order is required'),
            type: yup
              .string()
              .required('Type is required'),
            is_require: yup
              .boolean(), })}
          onSubmit={(values) => {
            editCustomOptionApi({
              dispatch,
              option: values
            });
            onClose(false);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue
          }) => (
            <>
              <form onSubmit={handleSubmit}>
                <CardHeader
                  className="px-0"
                  subheader="Custom Option"
                />
                <CardContent className="px-0 w-full flex justify-between">
                  <TextField
                    className="mx-3 w-full"
                    name="title"
                    label="Option Title"
                    value={values.title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ className: 'text-center' }}
                    error={touched.title && Boolean(errors.title)}
                    helperText={touched.title && errors.title}
                  />
                  <TextField
                    className="mx-3 w-full"
                    name="sort_order"
                    label="Order"
                    value={values.sort_order}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ className: 'text-center' }}
                    error={touched.sort_order && Boolean(errors.sort_order)}
                    helperText={touched.sort_order && errors.sort_order}
                  />
                  <TextField
                    className="mx-3 w-full"
                    name="type"
                    select
                    label="Type"
                    value={values.type}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={{ className: 'text-center' }}
                    error={touched.type && Boolean(errors.type)}
                    helperText={touched.type && errors.type}
                    disabled={values.is_swatch}
                  >
                    {types.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <FormControl aria-label="position" className="w-full max-w-150" row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.is_require}
                          color="primary"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="is_require"
                          disabled={values.is_swatch}
                        />}
                      label="Required"
                    />
                  </FormControl>
                  <FormControl aria-label="is_swatch" className="w-full max-w-150" row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.is_swatch}
                          color="primary"
                          onChange={(e) => {
                            const {checked} = e.target;
                            handleChange(e);

                            if (checked) {
                              setFieldValue('type', 'drop_down');
                              setFieldValue('is_require', 1);
                              setFieldValue('dermpro_option_gallery', 1);
                              setFieldValue('dermpro_option_image_mode', 1);
                            } else {
                              setFieldValue('type', '');
                              setFieldValue('dermpro_option_gallery', 0);
                              setFieldValue('dermpro_option_image_mode', 0);
                            }
                          }}
                          onBlur={handleBlur}
                          name="is_swatch"
                        />}
                      label="Is Swatch"
                    />
                  </FormControl>
                </CardContent>
                <DialogActions className="m-4">
                  <Button
                    className="text-muted"
                    onClick={() => onClose(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    type="submit"
                  >
                    Edit Custom Option
                  </Button>
                </DialogActions>
              </form>
            </>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default EditCustomOption;
